import '@babel/polyfill';
import 'moment-duration-format';
import 'scrollingelement';
import 'transitionEnd';
import React from 'react';
import {render} from 'react-dom';
import main from 'main';
import Root from 'RootDesktop';

const container = document.querySelector('.root');

const renderApp = pageInitData => {
    render(
        <Root pageInitData={pageInitData} />,
        container
    );
};

const initialize = () => {
    main.init({
        render: renderApp,
        isMobile: false
    });
};

initialize();
